import React, { useEffect, useState } from "react";
import { InventoryApiService } from "../../Service/InventoryApiService";
import { DataGrid } from '@mui/x-data-grid';
import { Tooltip, IconButton } from '@mui/material';
import { GridColDef } from "@mui/x-data-grid";
import "../Dynamic/UserList.scss";
import "../Dynamic/TransferLotBarrels.scss";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory, useParams } from "react-router";
import StickyNote2Icon from "@mui/icons-material/StickyNote2";
import { VisibilityOutlined } from "@mui/icons-material";
import { useRoute } from "../Common/route";
import StatusDropdown from "../Common/StatusDropdown";
import DataGridLoader from "../Common/DataGridLoader";

const TransferLotLogsPanel: React.FC = () => {

    const route = useRoute();
    const history = useHistory();
    const { id } = useParams<{ id: string }>();
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(50);
    const [transferLotLogs, setTransferLotLogs] = useState<any[]>([]);
   
    useEffect(() => {
        getAllOwnershipTransferLotLog(id);
    }, []);
   
    const getAllOwnershipTransferLotLog = async (transferRequestId: any) => {
        try {
            setLoading(true);
            const response = await InventoryApiService.getAllOwnershipTransferLotLog(transferRequestId);
            setTransferLotLogs(response.data || []);
        } catch (error) {
            console.error("Failed to fetch barrel sync logs", error);
        } finally {
            setLoading(false);
        }
    };

    //add tooltip
    const CellWithTooltip = ({ value }: { value: string | number }) => {
        return (
            <Tooltip arrow title={value?.toString()}>
                <span>{value?.toString()}</span>
            </Tooltip>
        );
    };

    const handleRowClick = (params) => {
        if(params.row.khTransferLotId != null)
            history.push(`/master/transfer-lot-barrels/${params.row.id}`);
    }

    const lotDataWithIds = transferLotLogs.map((rowData, index) => ({
        ...rowData,
    }));

    const columns: GridColDef[] = [
        {
            field: "lotNo",
            headerName: "Lot No",
            flex: 1,
            minWidth: 200,
            headerClassName: "table-header border-0 my-2 h-100",
            renderCell: (params: any) => (
                <CellWithTooltip value={params.value} />
            ),
        },
        {
            field: "newCompanyName",
            headerName: "New Owner",
            flex: 1,
            minWidth: 200,
            headerClassName: "table-header border-0 my-2 h-100",
            renderCell: (params: any) => (
                <CellWithTooltip value={params.value || "-"} />
            ),
        },
        {
            field: "oldCompanyName",
            headerName: "Old Owner",
            flex: 1,
            minWidth: 200,
            headerClassName: "table-header border-0 my-2 h-100",
            renderCell: (params: any) => (
                <CellWithTooltip value={params.value || "-"} />
            ),
        },
        {
            field: "quantity",
            headerName: "Quantity",
            flex: 1,
            headerClassName: "table-header border-0 my-2 h-100",
            renderCell: (params: any) => (
                <CellWithTooltip value={params.value || "-"} />
            ),
        },
        {
            field: "status",
            headerName: "Status",
            flex: 1,
            minWidth: 200,
            valueGetter: (value: any, row: any) => `${row.status ?? ""}`,
            headerClassName: "table-header border-0 my-2 h-100",
            renderCell: (params: any) => (
                    <div className="dropdown-nospacing" onClick={(e) => e.stopPropagation()}>
                        <StatusDropdown
                        currentStatus={params.row.status}
                        onStatusChange={(e) => console.log(e)}
                        disableCondition={true}
                        allowedLabels={[]}
                        />
                    </div> 
            )          
        },
        {
            field: "action",
            headerName: "Action",
            flex: 1,
            minWidth: 200,
            sortable: false,
            valueGetter: (value: any, row: any) => `${row.status ?? ""}`,
            headerClassName: "table-header border-0 my-2 h-100",
            renderCell: (params: any) =>
                // params.row.status === "COMPLETED" ? (
                //     <Tooltip title="View" arrow>
                //         <VisibilityOutlined 
                //             sx={{ marginTop: "5.5px" }}
                //             onClick={() => route(`/master/transfer-lot-barrels/${params.row.id}`)}
                //         />
                //     </Tooltip>       
                // ) :
                 params.row.status === "FAILED" && params.row.reason && (
                        <Tooltip title={`Reason: ${params.row.reason}`} arrow>
                            <StickyNote2Icon
                                className="note-icon cursor-pointer"
                                style={{ color: "gray" }}
                            />
                        </Tooltip>
                )  
        }
    ];

    const handleBack = () => {
        history.push("/master/barrel-sync-log");
    };

    const onPaginationModelChange = (newPaginationModel) => {
        setPage(newPaginationModel.page);
        setPageSize(newPaginationModel.pageSize);

        // Fetch using the latest sorting values
        getAllOwnershipTransferLotLog(id);
    };

    return (
        <div className="usersList pb-5">
            <div className="usersList__header--wrapper d-flex flex-wrap justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                    <IconButton
                        onClick={handleBack}
                        aria-label="ArrowBackIcon"
                        sx={{
                            backgroundColor: "#FFF",
                            mb: 1,
                            "&:hover": { backgroundColor: "#FFF" },
                        }}
                    >
                        <ArrowBackIcon sx={{ color: "#1C1B1F" }} />
                    </IconButton>
                    <div className="header--title mb-2 me-2">
                        <h1 className="title mb-0 ms-2">
                            Transfer Lot Logs
                        </h1>
                    </div>
                </div>

            </div>

            <div className="user-table-container">
                <div className="userTable">
                    <DataGrid
                        rows={lotDataWithIds}
                        columns={columns}
                        className="data-grid"
                        initialState={{
                            pagination: {
                                paginationModel: { page, pageSize },
                            },
                        }}
                        pagination
                        paginationModel={{ page, pageSize }}
                        onPaginationModelChange={onPaginationModelChange}
                        disableRowSelectionOnClick={true}
                        pageSizeOptions={[10, 20, 50, 100]}
                        loading={loading}
                        slots={{
                            loadingOverlay: DataGridLoader,
                        }}
                        disableColumnResize
                        onRowClick={handleRowClick}
                    />
                </div>
            </div>
        </div>

    );
};

export default TransferLotLogsPanel;